import { render, staticRenderFns } from "./CustomerViewLogs.vue?vue&type=template&id=7cd8b8cb"
import script from "./CustomerViewLogs.vue?vue&type=script&lang=js"
export * from "./CustomerViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports